import React from 'react';
import resolveIcon from '../utils/iconResolver';

const MetricToggle = ({ config, metric, onMetricChange }) => {
  const { options = [] } = config;

  return (
    <div className="flex rounded shadow-sm">
      {options.map((opt, i) => {
        const isFirst = i === 0;
        const isLast = i === options.length - 1;
        const isActive = metric === opt.value;
        const Icon = opt.icon ? resolveIcon(opt.icon) : null;
        const borderClass = isFirst
          ? 'rounded-l border'
          : isLast
            ? 'rounded-r border'
            : 'border-t border-b';
        return (
          <button
            key={opt.value}
            className={`px-2 py-1 text-xs font-medium ${borderClass} flex items-center ${
              isActive
                ? 'bg-success text-white border-success'
                : 'bg-white text-success border-gray-200 hover:bg-gray-50'
            }`}
            onClick={() => onMetricChange(opt.value)}
            title={opt.label}
          >
            {Icon ? <Icon className="text-xs" /> : opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default MetricToggle;
